var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlterardossie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71094 1.94238H17.4795C18.0136 1.94238 18.4712 2.13236 18.8516 2.5127C19.2317 2.89292 19.4218 3.34993 19.4219 3.88379V6.17969C18.8553 5.63124 18.2004 5.1738 17.4795 4.83203V3.88379H8.91016L6.96777 1.94238H1.94238V13.5947H7.4502C7.67211 14.2943 7.99793 14.9472 8.4082 15.5371H1.94238C1.40852 15.5371 0.951526 15.3469 0.571289 14.9668C0.190951 14.5865 0 14.1288 0 13.5947V1.94238C0 1.40829 0.190951 0.950651 0.571289 0.570312C0.951564 0.190132 1.40843 2.31726e-05 1.94238 0H7.76855L9.71094 1.94238Z",
    fill: "#6B671A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7469 14.5012H11.485L16.5482 9.438L15.8101 8.69989L10.7469 13.7631V14.5012ZM9.71094 15.5371V13.3357L16.5482 6.51146C16.6518 6.4165 16.7661 6.34312 16.8913 6.29132C17.0165 6.23952 17.1481 6.21362 17.2863 6.21362C17.4244 6.21362 17.5582 6.23952 17.6877 6.29132C17.8172 6.34312 17.9294 6.42081 18.0244 6.52441L18.7366 7.24957C18.8402 7.34453 18.9157 7.45675 18.9632 7.58625C19.0107 7.71574 19.0344 7.84523 19.0344 7.97473C19.0344 8.11285 19.0107 8.2445 18.9632 8.36968C18.9157 8.49486 18.8402 8.60924 18.7366 8.71284L11.9123 15.5371H9.71094ZM16.1726 9.07542L15.8101 8.69989L16.5482 9.438L16.1726 9.07542Z",
    fill: "#6B671A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlterardossie);
export default __webpack_public_path__ + "static/media/alterardossie.dfc807a9139fe347852e2d71f0dd115d.svg";
export { ForwardRef as ReactComponent };